import { memo } from 'react';
import { Typography, Box, Checkbox } from '@mui/material';
import { type SxProps } from '@mui/system';
import { checkedBox, clearFilter, uncheckedBox } from '@/assets';
import { t } from 'i18next';

import { Icon } from './Icon';
import { Row } from './Row';

type Props = {
  labels: Record<string, string>;
  onChange: (value: string) => void;
  value: string;
  sx?: SxProps;
  selected?: boolean;
  withCheckboxes?: boolean;
  checked?: string[];
  hideValue?: boolean;
  tryToDelete?: () => void;
  showDeleteIcon?: boolean;
  translate?: boolean;
};
const FormControlLabel = ({
  labels,
  sx,
  value,
  onChange,
  selected,
  withCheckboxes,
  checked,
  hideValue,
  tryToDelete,
  showDeleteIcon,
  translate,
}: Props) => {
  return (
    <Row
      onClick={() => onChange(value)}
      sx={{
        height: '2.0625rem', // 33px
        px: '0.125rem', // 2px
        cursor: 'pointer',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-around',
        borderBottom: '1px solid ',
        borderColor: selected ? 'primary.dark' : 'secondary.light',
        mx: '0.625rem', // 10px
        fontSize: '0.75rem', // 12px
        '&:hover': { bgcolor: 'secondary.contrastText' },
        ...sx,
      }}
    >
      {withCheckboxes && (
        <Checkbox
          size='small'
          checked={checked?.includes(value)}
          icon={<Icon src={uncheckedBox} />}
          checkedIcon={<Icon src={checkedBox} />}
        ></Checkbox>
      )}
      {!hideValue && (
        <Box
          sx={{
            width: '20%',
          }}
        >
          {labels.value}
        </Box>
      )}
      <Typography
        noWrap
        sx={{
          width: hideValue ? '100%' : '70%',
          fontWeight: 'revert',
          fontSize: 'revert',
        }}
      >
        {translate ? t(labels.label) : labels.label}
      </Typography>
      {showDeleteIcon && (
        <Box
          component='img'
          src={clearFilter}
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            tryToDelete?.();
          }}
          sx={{ cursor: 'pointer' }}
        />
      )}
    </Row>
  );
};
export const CustomFormControlLabel = memo(FormControlLabel) as (
  props: Props
) => React.ReactElement;
